import PaymentService from '@gachamonsters/payment-service';
import { getStoredAuthToken } from "@/lib/auth";

const host = import.meta.env.VITE_PAYMENT_SERVICE_HOST;
const paymentServiceAPI = new PaymentService({
    host: host
});

const getClient = () => {
    const { token } = getStoredAuthToken();
    if (!token) {
        throw new Error("No session found, please login.");
    }
    const client = paymentServiceAPI.getClient({
        gctAuthToken: token
    });
    return client
}

export async function purchaseCredits(currency: string, amount: number) {
    const client = getClient();
    const purchase = await client.walletAPI.purchaseCurrency({
        currency,
        amount
    });
    window.open(purchase.checkoutURL);
}

export async function getBalance(currency: string) {
    const client = getClient();
    const wallet = await client.walletAPI.getFunds({
        currency,
    });
    return wallet
}
